import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { AriaLiveMessage } from 'js/components/AriaLive'
import FilterWrapper from 'js/components/FilterWrapper'
import Flexer from 'js/components/Flexer/Flexer'
import Select from 'js/components/Select/Select'
import Text from 'js/components/Text/Text'

const ResultsHeader = ({
    total,
    orderBy,
    orderDirection,
    getSearchLink,
    style,
}) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    if (!total) {
        return null
    }

    const handleChangeSorting = (
        val: string | number | boolean | (string | number | boolean)[],
    ) => {
        const value = val as string
        const [orderby, orderdirection] = value.split('-')
        navigate(getSearchLink({ orderby, orderdirection }))
    }

    const sortOptions = [
        {
            value: 'score-asc',
            label: t('filters.sorting-relevance'),
        },
        {
            value: 'timePublished-desc',
            label: t('filters.sorting-published'),
        },
        {
            value: 'timePublished-asc',
            label: t('filters.sorting-published-old'),
        },
        {
            value: 'title-asc',
            label: t('filters.sorting-title'),
        },
        {
            value: 'title-desc',
            label: t('filters.sorting-title-old'),
        },
    ]

    const activeSortValue =
        !!orderBy && !!orderDirection
            ? `${orderBy}-${orderDirection}`
            : 'score-asc'

    return (
        <Flexer justifyContent="space-between" style={style}>
            <AriaLiveMessage
                message={t('global.result', {
                    count: total,
                })}
            />
            <Text
                as="h2"
                size="small"
                variant="grey"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 'auto',
                }}
            >
                {t('global.result', {
                    count: total,
                })}
            </Text>
            <FilterWrapper style={{ flexGrow: 1 }}>
                <Select
                    name="sort-search-results"
                    label={t('search.sort-by')}
                    options={sortOptions}
                    value={activeSortValue}
                    onChange={handleChangeSorting as any}
                    style={{
                        gridColumnEnd: '-1',
                    }}
                />
            </FilterWrapper>
        </Flexer>
    )
}

export default ResultsHeader
